"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Options for replacing tags using parentheses (`(` `)`).
 * Matches tags of the form `(variable)` in the text.
 * @example
 * // Example usage:
 * const text = 'Hello (variable)';
 * const result = replaceTags(text, { variable: 'world' }, Parentheses);
 * console.log(result); // Output: 'Hello world'
 */
var Parentheses = {
    name: "Parentheses",
    openingTag: "(",
    closingTag: ")",
    tagPattern: /\(([^)]+)\)/g,
    tagStartPattern: /^\(/,
    tagEndPattern: /\)$/,
};
exports.default = Parentheses;
